var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg13D(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "#38bdf8",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_503_117)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 11.4762,
    cy: 12.5238,
    r: 2.64286
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.4762 9.38095V5.19048M11.4762 5.19048L14.619 2.39683M11.4762 5.19048L8.33333 2.39683M11.4762 5.19048V1",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.8463 10.2841L16.7631 7.36731M16.7631 7.36731H20.6522M16.7631 7.36731V3.47822M16.7631 7.36731L19.68 4.45049",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.6826 14.5437L16.5995 17.4605M16.5995 17.4605H20.4885M16.5995 17.4605V21.3496M16.5995 17.4605L19.5163 20.3773",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.23651 14.5437L6.31969 17.4605M6.31969 17.4605H2.4306M6.31969 17.4605V21.3496M6.31969 17.4605L3.40288 20.3773",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.23651 10.2841L6.31969 7.36731M6.31969 7.36731H2.4306M6.31969 7.36731V3.47822M6.31969 7.36731L3.40288 4.45049",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.4762 15.6667V19.3333M11.4762 19.3333L14.619 21.7778M11.4762 19.3333L8.33333 21.7778M11.4762 19.3333V23",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.619 12.5238H18.8095M18.8095 12.5238L21.6032 15.6667M18.8095 12.5238L21.6032 9.38095M18.8095 12.5238H23",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.33333 12.5238H4.66667M4.66667 12.5238L2.22222 15.6667M4.66667 12.5238L2.22222 9.38095M4.66667 12.5238H1",
    strokeLinecap: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_503_117"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg13D);
export default __webpack_public_path__ + "static/media/13d.c810c8e573387c8a8c0b5d12d5424193.svg";
export { ForwardRef as ReactComponent };